import React from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

import usePersistedCollapse from '../../hooks/usePersistedCollapse';

// Generic, shared with every block type. Size is read-only here — a block
// type that supports resizing does it via handles on the canvas (see the
// Block capability contract), never through this sidebar. Falls back to
// showing the PRIMARY cell's own usable-area size when nothing is selected.
export default function SizePanel({ selectedBlock, cellWidthIn, cellHeightIn }) {
  const [collapsed, setCollapsed] = usePersistedCollapse('size');

  // Falls back to `size` for block types that are always square (e.g. QR)
  // and so don't carry independent width/height.
  const width = selectedBlock?.width ?? selectedBlock?.size;
  const height = selectedBlock?.height ?? selectedBlock?.size;
  const hasSize = selectedBlock && width != null && height != null;

  return (
    <div className="ss-print__panel">
      <div className="ss-print__panel-header">
        <h3 className="ss-print__panel-title">Size</h3>
        <button
          type="button"
          className="ss-print__lock-toggle"
          onClick={() => setCollapsed(!collapsed)}
          aria-expanded={!collapsed}
          aria-label={collapsed ? 'Expand size panel' : 'Collapse size panel'}
          title={collapsed ? 'Expand' : 'Collapse'}
        >
          {collapsed ? <ChevronRight size={16} aria-hidden="true" /> : <ChevronDown size={16} aria-hidden="true" />}
        </button>
      </div>

      {!collapsed && (
        <>
          <div className="ss-print__panel-row">
            <div className="ss-field">
              <span className="ss-label">W</span>
              <span>{hasSize ? width.toFixed(2) : selectedBlock ? '…' : cellWidthIn.toFixed(2)}</span>
            </div>
            <div className="ss-field">
              <span className="ss-label">H</span>
              <span>{hasSize ? height.toFixed(2) : selectedBlock ? '…' : cellHeightIn.toFixed(2)}</span>
            </div>
          </div>
          {!selectedBlock && <p className="ss-print__panel-hint">Cell size — select an element to see its size.</p>}
        </>
      )}
    </div>
  );
}
